// Needed to support async await
import 'regenerator-runtime/runtime'
import App from './App'
import render from 'commons/js/util/render'
import { init } from 'commons/js/util/reporter'

init()

const element = document.querySelector('.js-vehicle-filter')
const { dataset } = element
const product = JSON.parse(dataset.product)
const station = JSON.parse(dataset.station)

const props = {
    product: {
        originalPrice: product.original_price,
        totalPrice: product.online_price,
    },
    station: {
        name: station.name,
        id: station.id,
    },
}

render({ App, element, props })
